import { Video } from "@tamagui/lucide-icons";

import { Text, XStack } from "@/components";

interface VideoVisitStatusProps {
  content: string;
}
const VideoVisitStatus = ({ content }: VideoVisitStatusProps) => {
  return (
    <XStack
      gap="$200"
      borderRadius="$150"
      padding="$200"
      marginVertical="$100"
      alignItems="center"
      flexWrap="wrap"
      borderWidth="$strokeWidth"
      borderColor="$strokeSubdued"
    >
      <Video size="$300" color="$iconBase" flexShrink={0} />
      <Text size="$sm">{content}</Text>
    </XStack>
  );
};

export default VideoVisitStatus;
